<template>
  <v-container
      fluid
  >
    <v-card class="pa-5" tile>
      <v-form
        autocomplete="off"
        @submit="function(e){saveItem();e.preventDefault()}"
      >

        <v-row class="mt-n5">
            <v-col sm="2" class="px-0">
                {{ $t('Appointment location') }}
            </v-col>
            <v-col sm="6" class="px-0">
                <v-select
                    v-model="search.appointment_location_ids"
                    :error-messages="errors.appointment_location_ids"
                    :items="appointment_locations"
                    filled
                    chips
                    dense
                    multiple
                    clearable
                    tabindex="20"
                />
            </v-col>
        </v-row>

        <v-row class="mt-n5">
            <v-col sm="2" class="px-0">
                {{ $t('Dentist') }}
            </v-col>
            <v-col sm="6" class="px-0">
                <v-select
                    v-model="search.dentist_ids"
                    :error-messages="errors.dentist_ids"
                    :items="dentists"
                    filled
                    chips
                    dense
                    multiple
                    clearable
                    tabindex="20"
                />
            </v-col>
        </v-row>

        <v-row class="mt-n5">
          <v-col cols="2" sm="2" class="px-0">
            {{ $t('Date of visit') }}
          </v-col>
          <v-col cols="3" sm="3" class="px-0">
            {{ $t('From') }}
            <date-picker-field
                v-model="search.from_date"
                :error-messages="errors.from_date"
                :label="undefined"
                clearable
                tabindex="30"
            >
            </date-picker-field>
          </v-col>
          <v-col cols="3" sm="3" class="px-0">
            {{ $t('To') }}
            <date-picker-field
                v-model="search.to_date"
                :error-messages="errors.to_date"
                :label="undefined"
                clearable
                tabindex="35"
            >
            </date-picker-field>
          </v-col>
        </v-row>

        <v-row class="mt-n5">
          <v-col cols="2" sm="2" class="px-0">
            {{ $t('Next appointment') }}
          </v-col>
          <v-col cols="3" sm="3" class="px-0">
            {{ $t('From') }}
            <date-picker-field
                v-model="search.from_next_appointment_date"
                :error-messages="errors.from_next_appointment_date"
                :label="undefined"
                clearable
                tabindex="30"
            >
            </date-picker-field>
          </v-col>
          <v-col cols="3" sm="3" class="px-0">
            {{ $t('To') }}
            <date-picker-field
                v-model="search.to_next_appointment_date"
                :error-messages="errors.to_next_appointment_date"
                :label="undefined"
                clearable
                tabindex="35"
            >
            </date-picker-field>
          </v-col>
        </v-row>

        <v-row class="mt-n5">
            <v-col sm="2" class="px-0">
                {{ $t('Type of lip status') }}
            </v-col>
            <v-col sm="6" class="px-0">
                <v-select
                    v-model="search.revision_lip_statuses"
                    :error-messages="errors.revision_lip_statuses"
                    :items="revision_lip_status_options"
                    filled
                    chips
                    dense
                    multiple
                    clearable
                    tabindex="20"
                />
            </v-col>
        </v-row>

        <v-row class="mt-n5">
            <v-col sm="2" class="px-0">
                {{ $t('Revision lip') }}
            </v-col>
            <v-col sm="6" class="px-0">
                <v-select
                    v-model="search.revision_lip_ids"
                    :error-messages="errors.revision_lip_ids"
                    :items="revision_lip_options"
                    filled
                    chips
                    dense
                    multiple
                    clearable
                    tabindex="20"
                />
            </v-col>
        </v-row>

        <v-row class="mt-n5">
            <v-col sm="2" class="px-0">
                {{ $t('Type of palate status') }}
            </v-col>
            <v-col sm="6" class="px-0">
                <v-select
                    v-model="search.revision_palate_statuses"
                    :error-messages="errors.revision_palate_statuses"
                    :items="revision_palate_status_options"
                    filled
                    chips
                    dense
                    multiple
                    clearable
                    tabindex="20"
                />
            </v-col>
        </v-row>

        <v-row class="mt-n5">
            <v-col sm="2" class="px-0">
                {{ $t('Revision palate') }}
            </v-col>
            <v-col sm="6" class="px-0">
                <v-select
                    v-model="search.revision_palate_ids"
                    :error-messages="errors.revision_palate_ids"
                    :items="revision_palate_options"
                    filled
                    chips
                    dense
                    multiple
                    clearable
                    tabindex="20"
                />
            </v-col>
        </v-row>

        <v-row class="mt-n5">
          <v-col cols="2" sm="2" class="px-0">
            {{ $t('Date of birth') }}
          </v-col>
          <v-col cols="3" sm="3" class="px-0">
            {{ $t('From') }}
            <date-picker-field
                v-model="search.from_birth_date"
                :error-messages="errors.from_birth_date"
                :label="undefined"
                clearable
                tabindex="30"
            >
            </date-picker-field>
          </v-col>
          <v-col cols="3" sm="3" class="px-0">
            {{ $t('To') }}
            <date-picker-field
                v-model="search.to_birth_date"
                :error-messages="errors.to_birth_date"
                :label="undefined"
                clearable
                tabindex="35"
            >
            </date-picker-field>
          </v-col>
        </v-row>

        <v-row class="mt-n5">
            <v-col sm="2" class="px-0">
                {{ $t('Main status') }}
            </v-col>
            <v-col sm="6" class="px-0">
                <v-select
                    v-model="search.main_status_ids"
                    :error-messages="errors.main_status_ids"
                    :items="main_statuses"
                    filled
                    chips
                    dense
                    multiple
                    clearable
                    tabindex="50"
                />
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="2" sm="2" class="px-0">
                {{ $t('Action') }}
            </v-col>
            <v-col cols="2" sm="2" class="px-0">
                <v-btn @click="resetForm">{{ $t('Clear form') }}</v-btn>
                &nbsp;
                <v-btn @click="exportXls">{{ $t('Export XLS') }}</v-btn>
            </v-col>
        </v-row>

      </v-form>

    </v-card>
  </v-container>

</template>

<script>
import ApiService from '@/services/api.service'
import DatePickerField from '@/components/DatePickerField'
import {fetchMultipleLists2} from '@/lib/helpers'

export default {
  components: {
    DatePickerField,
  },
  data: () => ({
    errors: {},
    search: {},

    appointment_locations: [],
    dentists: [],
    revision_lip_status_options: [],
    revision_lip_options: [],
    revision_palate_status_options: [],
    revision_palate_options: [],
    main_statuses: [],
  }),
  watch: {
    '$i18n.locale': function () {
        this.fetchTranslatables()
    },
  },
  methods: {
    resetForm() {
      this.search = {
        appointment_location_ids: null,
        dentist_ids: null,
        from_date: null,
        to_date: null,
        from_next_appointment_date: null,
        to_next_appointment_date: null,
        revision_lip_statuses: null,
        revision_lip_ids: null,
        revision_palate_statuses: null,
        revision_palate_ids: null,
        from_birth_date: null,
        to_birth_date: null,
        main_status_ids: null,
      }
    },
    getItem() {
      const item = this.search
      return item
    },
    exportXls() {
      this.errors = {}
      this.$store.dispatch('session/showLoader')
     
      ApiService.download(`/exports/dental/xls`, { filter: this.search }).then(response => {
        this.openFile(response.data, response.filename)
      }).catch(errors => {
        this.errors = errors
        console.log(errors)
      }).finally(() => {
        this.$store.dispatch('session/hideLoader')
      })
    },
    openFile(blob, filename) {
        const data = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = data;
        link.download=filename;
        link.click();
        setTimeout(function(){
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
        }, 100);
    },    
    fetchTranslatables() {
        fetchMultipleLists2(this, {
            // These must be listed in created() as well
            revision_lip_options: 'type_of_surgery',
            revision_palate_options: 'type_of_surgery',
            main_statuses: 'main_status',
        }, '/master-files/get-multiple-lists', 'master_file_type_tags')

        fetchMultipleLists2(this, {
            // These must be listed in created() as well
            revision_lip_status_options: 'revision_lip_status_options',
            revision_palate_status_options: 'revision_palate_status_options',
        }, '/surgeries/get-multiple-lists', 'master_file_type_tags')
    },
  },
  created() {
    this.resetForm();
    this.$store.dispatch('session/title', 'Reports - Dental')
    fetchMultipleLists2(this, {
        // Non-translatable
        appointment_locations: 'appointments_where',
        dentists: 'dentist',

        // Translatable; must be listed in fetchTranslatables() as well
        revision_lip_options: 'type_of_surgery',
        revision_palate_options: 'type_of_surgery',
        main_statuses: 'main_status',
    }, '/master-files/get-multiple-lists', 'master_file_type_tags')

    fetchMultipleLists2(this, {
        // These must be listed in created() as well
        revision_lip_status_options: 'revision_lip_status_options',
        revision_palate_status_options: 'revision_palate_status_options',
    }, '/surgeries/get-multiple-lists', 'master_file_type_tags')
  },
}
</script>

<style scoped>

</style>
